import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permissions.service';

@Injectable()
export class ProjectCreationGuard {
  constructor(
    private readonly route: Router,
    private readonly authService: AuthService,
    private readonly permissionService: PermissionService
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    // If no logged in, redirect to /login
    if (!this.authService.getAuthUser()) {
      this.route.navigate(['/entry']);
      return false;
    }

    if (this.permissionService.canCreateProject()) {
      return true;
    } else {
      this.route.navigate(['/workspaces/projects']);
      return false;
    }
  }
}
